module.exports = ".content-page { \n  height: 100%;\n}\n\np, h1 { \n  color: black; \n}\n\n.jumbotron{\n  margin-top: 5%;\n}"